import { useMemo } from 'react';
import { useGetCitiesQuery } from '../../Cities/services/cities.service';

const useCitiesOptions = () => {
  const { data: cities, isLoading } = useGetCitiesQuery({
    paginated: {
      page: 1,
      pageSize: 1000,
    },
  });

  const options = useMemo(() => {
    return (
      cities?.items?.map((city) => ({
        value: city.id,
        label: city.name,
      })) || []
    );
  }, [cities?.items]);

  return {
    options,
    isLoading,
  };
};

export default useCitiesOptions;
